"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
export function FormGrid({ className, ...props }) {
    return _jsx("div", { className: clsx("grid gap-3", className), ...props });
}
export function Field({ className, ...props }) {
    return _jsx("div", { className: clsx("space-y-2", className), ...props });
}
export function FieldLabel({ className, ...props }) {
    return _jsx("label", { className: clsx("block text-sm font-medium opacity-80", className), ...props });
}
export function FieldHint({ className, ...props }) {
    return _jsx("p", { className: clsx("text-xs opacity-60", className), ...props });
}
export const TextInput = forwardRef(({ className, startAdornment, endAdornment, ...props }, ref) => {
    if (!startAdornment && !endAdornment) {
        return _jsx("input", { ref: ref, className: clsx("app-input", className), ...props });
    }
    return (_jsxs("div", { className: clsx("flex items-center gap-2 rounded-xl border border-white/10 bg-black/30 px-3", className), children: [startAdornment ? _jsx("span", { className: "text-xs opacity-70", children: startAdornment }) : null, _jsx("input", { ref: ref, className: "h-10 flex-1 bg-transparent outline-none", ...props }), endAdornment ? _jsx("span", { className: "text-xs opacity-70", children: endAdornment }) : null] }));
});
TextInput.displayName = "TextInput";
export const Fieldset = ({ className, ...props }) => (_jsx("fieldset", { className: clsx("grid gap-2", className), ...props }));
export const Legend = ({ className, ...props }) => (_jsx("legend", { className: clsx("text-sm font-semibold", className), ...props }));
export function ButtonRow({ className, ...props }) {
    return _jsx("div", { className: clsx("flex flex-wrap items-center gap-3", className), ...props });
}
